// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar-module__avatar","primary":"Avatar-module__primary"};